import State from './State';
import focusWithin from './FocusWithin';

const settings = {
    namespace: 'main-nav',
    header: '.header',
};

focusWithin(document);

new State(settings);
